<template>
  <div>
    <div class="header">
      <span class="back" @click="back">{{ $t("index.back") }}</span>
    </div>
    <div class="inner">
      <div class="menu">
        <a-input-search
          v-model:value="searchValue"
          style="margin: 10px 0px"
          :placeholder="$t('index.queryTree')"
        />
        <a-menu
          v-model:selectedKeys="current"
          :items="items"
          mode="inline"
          @click="handleClick()"
          v-model:openKeys="openKeys"
          id="folderMenu"
        />
      </div>
      <div class="tab">
        <a-table
          ref="table"
          :columns="columns"
          :dataSource="dataSource"
          :row-key="(record) => record.Id"
          :loading="loading"
          style="border-radius: 0px"
          :bordered="false"
        >
          <template #operator class="table-operator"> </template>
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'action'">
              <a @click="article(record)">{{ $t("index.look") }}</a>
            </template>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * CreationTime：2024.6.5 Wen
 * LastEditingTime：2024.6.5 Wen
 * Written by ShiYechen
 */
import { h, ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { FolderOutlined, FileOutlined } from "@ant-design/icons-vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

const { t } = useI18n();
let route = useRoute();
let router = useRouter();
localStorage.setItem("router", "download");
console.log(localStorage.getItem("router"));

/**左侧菜单选中节点 */
const current = ref([]);
/**数组，盛放左侧目录元素 */
const items = ref([]);
/**数组，盛放展开的节点 */
const openKeys = ref([]);
const searchValue = ref("");

// 定义tableDOM
const table = ref(null);
const dataSource = ref([]);
const loading = ref(false);
/**table表头数据 */
const columns = [
  {
    title: t("repair.repairtb1"),
    dataIndex: "Title",
  },
  {
    title: t("repair.repairtb2"),
    dataIndex: "Lable",
  },
  {
    title: t("repair.repairtb3"),
    dataIndex: "action",
    align: "center",
  },
];
const dataList = ref([]);

watch(searchValue, (value) => {
  if (searchValue.value && searchValue.value != "") {
    const expanded = dataList.value
      .map((item) => {
        if (item.label.indexOf(value) > -1) {
          return getParentKey(item.key, items.value);
        }
        return null;
      })
      .filter((item, i, self) => item && self.indexOf(item) === i);
    openKeys.value = expanded;
    searchValue.value = value;
  }
});

/**主函数入口 */
init();

async function init() {
  await getTreeData()
    .then((data) => {
      if (Array.isArray(data)) {
        if (data[0].name == "根目录") {
          let menu = data[0].children;
          copyTransFun(menu);
          items.value = menu;
          filterData(current.value[0]);
          generateList(items.value);
        }
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

function getParentKey(key, tree) {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
}

/**根据菜单查询内容 */
function filterData(pararms) {
  loading.value = true;
  axios
    .post("api/SoftwareDownload/GetContents", {
      Id: "",
      NodeId: pararms,
      Title: "",
      Lable: "",
    })
    .then((response) => {
      if (response.data.info != 200 && response.data.ReturnData != "暂无数据") {
        dataSource.value = response.data.ReturnData;
      } else if (response.data.ReturnData == "暂无数据") {
        dataSource.value = [];
      } else {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      loading.value = false;
    });
}

/**处理架构树 */
function copyTransFun(arr) {
  arr.forEach((item) => {
    if (item.id) {
      item.key = item.id;
    }
    if (item.name) {
      item.label = item.name;
    }
    if (item.children && item.children.length) {
      item.icon = () => h(FolderOutlined);
      copyTransFun(item.children);
    } else {
      delete item.children;
      item.icon = () => h(FileOutlined);
      if (current.value.length == 0) {
        current.value.push(item.key);
        openKeys.value.push(item.parentId);
      }
    }
  });
}

function generateList(data) {
  for (let i = 0; i < data.length; i++) {
    const node = data[i];
    dataList.value.push({
      key: node.key,
      label: node.label,
    });
    if (node.children) {
      generateList(node.children);
    }
  }
}

/**左侧菜单点击事件 */
function handleClick() {
  setTimeout(function () {
    filterData(current.value[0]);
  }, 0);
}

/**获取架构树 */
function getTreeData() {
  return new Promise((resolve, reject) => {
    axios
      .post("api/SoftwareDownload/GetJstreeData")
      .then(function (response) {
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**架构树展开回调 */
function onExpand(keys) {
  expandedKeys.value = keys;
}

/**跳转到文章页面 */
function article(record) {
  const routeUrl = router.resolve({
    name: "softwareDown",
    params: {
      id: record.Id,
      parentId: record.NodeId,
      isVisitor: false,
    },
  });
  window.open(routeUrl.href, "_blank");
}

/**返回主页面 */
function back() {
  router.push(`/index/use`);
}
</script>

<style scoped>
.inner {
  display: flex;
  justify-content: space-between;
  padding: 0px 2% 0px 0px;
  margin-top: 60px;
}
.menu {
  width: 20%;
  height: 100%;
}
.tab {
  width: 78%;
}
a {
  color: #1890ff;
}
.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}
</style>
